module.exports = __webpack_public_path__ + "static/media/rm_logo.dcc030fe.png";